var React = require('react');
var helpers = require('svg-react-loader/helpers')(require('react-dom'));

module.exports = React.createClass({

    displayName: "MinusCircleFilled",

    getDefaultProps () {
        return {"xmlns":"http://www.w3.org/2000/svg","className":"dibsvg-svg dibsvg-minus","viewBox":"0 0 438.533 438.533"};
    },

    componentDidMount () {
        helpers.applyXmlAttributes(this);
    },

    render () {
        var props = this.props;
        var children = props.children;

        return (
            <svg {...this.props}>
                  <path d="M409.133 109.203c-19.608-33.592-46.205-60.189-79.798-79.796C295.736 9.801 259.058 0 219.273 0c-39.781 0-76.47 9.801-110.063 29.407-33.595 19.604-60.192 46.201-79.8 79.796C9.801 142.8 0 179.489 0 219.267c0 39.78 9.804 76.463 29.407 110.062 19.607 33.592 46.204 60.189 79.799 79.798 33.597 19.605 70.283 29.407 110.063 29.407s76.47-9.802 110.065-29.407c33.593-19.602 60.189-46.206 79.795-79.798 19.603-33.596 29.403-70.284 29.403-110.062.001-39.782-9.8-76.472-29.399-110.064zm-61.954 128.336c0 4.948-1.811 9.236-5.428 12.847-3.614 3.614-7.898 5.428-12.847 5.428h-219.27c-4.948 0-9.229-1.813-12.847-5.428-3.616-3.61-5.424-7.898-5.424-12.847v-36.547c0-4.948 1.809-9.231 5.424-12.847 3.617-3.617 7.898-5.426 12.847-5.426h219.27c4.948 0 9.232 1.809 12.847 5.426 3.617 3.615 5.428 7.898 5.428 12.847v36.547z"/>
                {React.Children.map(children, (c) => (c))}
            </svg>
        );
    }
});



// WEBPACK FOOTER //
// ./src/minus-circle-filled.svg